import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAdminPermissions } from 'src/hooks/useAdminPermissions';
import Unauthorized from 'src/pages/Unauthorized/Unauthorized';
import { getFirstAccessibleRoute, getRoutePermission, hasPermission } from 'src/utils/permissions';
import { SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP } from 'src/utils/constants';
import { ROUTE_LOGIN } from 'src/utils/routes';

type ProtectedRouteProps = {
  permission?: string;
  children: React.ReactNode;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ permission, children }) => {
  const location = useLocation();
  const { permissions, loading, initialized, error } = useAdminPermissions();

  const accessToken = localStorage.getItem('access');
  const requiredPermission = permission ?? getRoutePermission(location.pathname);

  if (!accessToken) {
    return <Navigate to={ROUTE_LOGIN} replace state={{ from: location.pathname }} />;
  }

  if (!initialized || loading) {
    return null;
  }

  if (error && !permissions.length) {
    return <Navigate to={ROUTE_LOGIN} replace />;
  }

  if (requiredPermission && !hasPermission(permissions, requiredPermission)) {
    const fallbackRoute = getFirstAccessibleRoute(permissions, SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP);

    if (fallbackRoute && fallbackRoute !== location.pathname) {
      return <Navigate to={fallbackRoute} replace />;
    }

    return <Unauthorized />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
